/**
 * The external dependencies.
 */
import {createSelector} from 'reselect';
import * as R from 'ramda';
import moment from 'moment';
import 'moment/locale/de';
/**
 * The internal dependencies.
 */
import {getAuthUser} from '../../store/auth/selectors';
import {getSortingFormattedValue} from './utilities';
import {initArray} from '../../common/utilities';
import {FULL_DATE_FORMAT} from '../../common/constants';
import {combineAuth, filterlastworkstep, getFilterbysteps} from "../auth/selectors";
//get tasks Items and remove empty
export const getCurrentTask = ({tasks}) => {
    return tasks.current;
};

export const getTasksItems = ({tasks}) => tasks.items;//.filter(function (el) { return el != null; });

export const getTasksOrders = ({tasks: {orders}}) => {
    const ids = R.pluck('id', orders);
    if (!R.isEmpty(ids)) {
        return R.zipObj(ids, orders);
    } else {
        return null;
    }
};

export const combineTaskOrder = createSelector(
    getTasksItems,
    getTasksOrders,
    (items, orders) => {
        return {items, orders};
    }
);

export const getUser = ({user}) => user;

export const getFormattedTasksColumns = ({tasks}) => tasks.formattedTasksColumns;

export const getErpFilter = ({tasks}) => tasks.erpFilter;
export const getOrderFilter = ({tasks}) => tasks.orderFilter;
export const getCustomFilter = ({tasks}) => tasks.customFilter;

export const getTasksFormattedItems = (store, doneOverride = false) => {

    let items = getTasksItems(store);
    if (R.length(items) === 0) return [];

    const auth = combineAuth(store);
    let orders = getTasksOrders(store);
    let erpFilter = getErpFilter(store);
    let orderFilter = getOrderFilter(store);
    let customFilter = getCustomFilter(store);
    let filterbysteps = getFilterbysteps(store);
    let user = auth.user;
    if (R.isNil(user) || R.isEmpty(user)) return [];
    let userId = user.id;
    let userDepartment = user.departmentEntity;
    const diff = function (a, b) {
        return a - b;
    };
    let userSteps = user.validSteps != null ? R.dropLast(1, R.sort(diff, R.concat(R.map((step) => R.subtract(step, 1), user.validSteps), user.validSteps))) : [];
    let freeUser = auth.freeUser;
    const workstepCount = getWorkstepcount(store);

    if (!R.isEmpty(items) && !R.isEmpty(orders)) {
        const myitems = items.map((item, index) => (
            {
                ...item,
                date: ((item.date) ? item.date : moment().toISOString(true)),
                priority: R.isNil(item.priority) ? index * 10 : item.priority,
                id: item.id,
                // 'id': item.id,
                erpnumber: item.erpnumber,
                erpnumberSmall: R.isEmpty(item.erpnumberSmall) ? item.erpnumber : item.erpnumberSmall,
                owningTaskErp: R.isEmpty(item.owningTaskErp) || R.isNil(item.owningTaskErp) ? '-' : item.owningTaskErp + "-" + R.takeLastWhile(x => x !== '-', item._id),
                order_client: orders[item.order_id].client,
                order_deadline: R.isNil(item.deliveryDate) || item.deliveryDate === undefined ? orders[item.order_id].due_at : item.deliveryDate,
                order_quantity: item.quantity,
                order_number: orders[item.order_id].orderNumber,
            }

        ));

        const sortByPriority = R.sortWith([R.ascend(R.prop('priority'))]);

        // DEFINE Filters:
        const isVisible = item => {
            if (item.userId === userId) return true;
            if (R.isEmpty(item.departmentIds) || R.isNil(item.departmentIds)) return false;
            // if ((R.isEmpty(userDepartment) || R.isNil(userDepartment))) return true;
            if (R.isNil(R.find((id) => id === userDepartment)(item.departmentIds))) {
                return false;
            } else if (filterbysteps) {
                if (item.step == null || item.step === 0) return true;
                if (R.isNil(R.find((step) => step === item.step)(userSteps))) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        };

        const isLastWorkstep = item => {
            if (item.step === workstepCount) {
                return false;
            }
            return true;
        };

        const containsErpFilter = item => {
            if (erpFilter === '' || erpFilter === null || erpFilter === undefined) return true;
            if (R.startsWith(R.toLower(erpFilter), R.toLower(item.erpnumber))) return true;
            return false;
        }

        const containsOrderFilter = item => {
            if (orderFilter === '' || orderFilter === null || orderFilter === undefined) return true;
            if (R.includes(R.toLower(orderFilter), R.toLower(item.order_number))) return true;
            return false;
        }


        const containsCustomFilter = item => {
            if (customFilter === {} || customFilter === null || customFilter === undefined || R.isEmpty(customFilter) || R.isEmpty(customFilter.filter) || R.isEmpty(customFilter.filter.value)) return true;
            if (R.includes(R.toLower(customFilter.value), R.toLower(R.prop(customFilter.filter.value, item)))) return true;
            return false;
        }

        let filteredItems = myitems;

        // Apply Filters according configuration:
        if (filterlastworkstep(store) && !doneOverride) {
            filteredItems = (R.filter(containsCustomFilter)(R.filter(isLastWorkstep, myitems)));
        }

        if (freeUser) {
            let sort = (R.filter(containsCustomFilter)(sortByPriority(filteredItems)))
            return sort;
        }

        let sort = sortByPriority((R.filter(containsCustomFilter)(R.filter(isVisible, filteredItems))));
        return sort;

    } else {
        return [];
    }
};

export const getTasksForCurrentUser = createSelector(
    getTasksFormattedItems,
    getAuthUser,
    (tasks, user) => {
        return R.filter(R.propEq('worker', user.fullname))(tasks)
    }
);


export const getTasksReserved = createSelector(
    getTasksForCurrentUser,
    (tasks) => {
        // onsole.log("getTasksReserved");
        return R.filter(R.propEq('status', 'reserved'))(tasks)
    }
);

export const getTasksInProgress = createSelector(
    getTasksForCurrentUser,
    (tasks) => {
        // console.log("getTasksInProgress");
        return R.filter(R.propEq('status', 'in-progress'))(tasks)
    }
);

export const getTasksCountForCurrentUsers = createSelector(
    getTasksForCurrentUser,
    (tasks) => {
        // console.log("getTasksCountForCurrentUsers");
        return R.length(tasks)
    },
);

export const getTasksCurrent = createSelector(
    // getTasksFormattedItems,
    getCurrentTask,
    (tasks) => {
        return R.defaultTo({})(tasks);
        // return R.defaultTo({})(R.find(R.propEq('current', true))(tasks))
    }
);

export const getTasksSorting = ({tasks}) => tasks.sorting;

export const getTasksSortingPaginationValue = ({tasks}) => tasks.sortingPaginationValue;

export const getTasksFormattedSortingPaginationValue = ({tasks}) => getSortingFormattedValue(tasks.sorting, tasks.sortingPaginationValue);

export const getTasksSortingTaskKey = ({tasks}) => {
    const {sorting} = tasks;
    return (sorting === 'week') ? 'date' : null;
};

export const getFilteredSortingPageValues = createSelector(
    getTasksSorting,
    getTasksSortingPaginationValue,
    (sort, paginationValue) => {
        if (sort === 'week' && paginationValue) {
            const parser = moment(paginationValue.format('YYYY-MM-DD'));
            return initArray(5).map((v, i) => {
                const value = R.clone(parser.weekday(i));
                return {sortingValue: value, label: value.format('dd DD.MM.YYYY')};
            });
        }
    });

export const getTaskColumnHeadings = ({tasks}) => {
    const sortingValues = R.clone(getFilteredSortingPageValues({tasks}));
    return (!sortingValues) ? null : R.pluck('label')(sortingValues);
};

export const getTaskColumns = (state, selector) => {
    const items = selector(state);
    return getTaskColumnsPure(state, items)
};

export const getTaskColumnsPure = (state, items) => {
    const sortings = R.clone(getFilteredSortingPageValues(state));
    if (!sortings) return initArray(5);

    // Obsolete at the moment - only week filtration implemented
    // const sortingTaskKey = getTasksSortingTaskKey(state);
    const format = 'YYYY DD MM';

    const sortingValues = R.pluck('sortingValue', sortings);
    const ids = sortingValues.map(val => val.format(FULL_DATE_FORMAT));

    return R.zipObj(ids, sortingValues.map(val => items.filter(({date}) => moment(date).format(format) === val.format(format))));
};

export const getTaskColumnsAndTasks = (state) => {
    let items = getTasksFormattedItems(state);
    return {tasks: items, columns: getTaskColumnsPure(state, items)}
}

export const getTaskColumnsAndTasksDone = (state) => {
    const isDone = (task) => {
        if (state.auth.disponent) {
            return task.status === 'done' && task.step === state.tasks.workstepcount;
        } else {
            return task.status === 'done' && task.step === state.tasks.workstepcount && task.worker === state.auth.user.fullname;
        }
    };
/*    let items = [];
    try {
        items = R.filter(isDone)(getTasksFormattedItems(state, true));
    } catch (e) {
        items = [];
    }*/

    const result = getFormattedTasksColumns(state);
    return {tasks: R.filter(isDone)(result.items), columns: result.columns}
}

export const getTaskSteps = ({tasks}) => tasks.workSteps;

export const getTaskWorkSteps = ({tasks}) => tasks.workSteps;

export const getAllTaskWorkSteps = ({tasks}) => tasks.allWorkSteps;

export const getTaskStepsLabels = ({tasks}) => R.pluck('name')(tasks.workSteps);

export const getTaskWorkStepsName = ({tasks}) => R.pluck('name')(tasks.workSteps);

export const getTaskStepsCount = ({tasks}) => R.length(tasks.workSteps);

export const getTaskWorkplaces = ({tasks}) => tasks.workplaces;

export const getTaskErrormessage = ({tasks}) => tasks.errormessage;

export const getTaskErrormessageRevieved = ({tasks}) => tasks.errormessageRevieved;

export const getTaskCurrentTracking = ({tasks}) => tasks.currentTracking;

export const getWorkstepcount = ({tasks}) => tasks.workstepcount;

export const getcurrentChildren = ({tasks}) => tasks.currentChildren;

export const getCurrentInstructions = ({tasks}) => tasks.currentInstructions;

export const getCurrentHandbook = ({tasks}) => tasks.currentHandbook;

export const getLoadingTasks = ({tasks}) => tasks.loadingTasks;





// WEBPACK FOOTER //
// ./src/store/tasks/selectors.js